import { ConeSide } from './ConeSide';
export class ConeLeftSide extends ConeSide {
    constructor(cone) {
        super();
        this.Cone = cone;
    }
    get Start() {
        return this.Cone.Apex;
    }
    get Direction() {
        return this.Cone.LeftSideDirection;
    }
    toString() {
        return 'ConeLeftSide ' + this.Start + (' ' + this.Direction);
    }
}
//# sourceMappingURL=ConeLeftSide.js.map